export const DB_CONFIG = {
  apiKey: "AIzaSyDSJ3vxq-KO36W_cc369Ph3DDuxkJWIzsw",
  authDomain: "survey-cc885.firebaseapp.com",
  databaseURL: "https://survey-cc885.firebaseio.com",
  projectId: "survey-cc885",
  storageBucket: "survey-cc885.appspot.com",
  messagingSenderId: "4024497775"
}


// WEBPACK FOOTER //
// ./src/config/firebase.config.js